import { IconButton } from '@ui/kit';
import { DotsIcon } from '@ui/kit/icons';
import { jsx } from 'react/jsx-runtime';

function ContextAction({
  showContextmenu,
  dropdownTriggerRef,
  onClick
}) {
  return /*#__PURE__*/jsx(IconButton, {
    active: showContextmenu,
    ref: dropdownTriggerRef,
    icon: /*#__PURE__*/jsx(DotsIcon, {}),
    label: "\xC5bn kontekstmenu",
    onClick: evt => {
      evt.stopPropagation();
      onClick();
    }
  });
}

export { ContextAction };
//# sourceMappingURL=actions.context.js.map
